import { useController } from 'react-hook-form';
import ToggleButtonGroupBase, {
  ToggleButtonGroupBaseType,
} from './toggle-button-group-base/toggle-button-group-base.component';

export type ToggleButtonGroupFieldType = Omit<
  ToggleButtonGroupBaseType,
  'onChange' | 'value'
> & { fieldOnChangeAdditionalLogic?: (val: any) => void };

const ToggleButtonGroupField = ({
  name,
  fieldOnChangeAdditionalLogic,
  ...rest
}: ToggleButtonGroupFieldType) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  const onChange = value => {
    fieldOnChangeAdditionalLogic?.(value);
    field.onChange(value);
  };

  return (
    <ToggleButtonGroupBase
      onChange={onChange}
      value={field.value}
      error={error}
      name={name}
      ref={field.ref}
      {...rest}
    />
  );
};

export default ToggleButtonGroupField;
